if (!rtAPI) var rtAPI = {};
if (!rtAPI.security) rtAPI.security = {};
if (!rtAPI.security.hardwareKey) rtAPI.security.hardwareKey = { debugEnabled: false };

//#region Hardware Key Sign In

rtAPI.security.hardwareKey.triggerLogin = async function () {
    let success = await rtAPI.security.hardwareKey.loginStep1();
    //if (!success) return false;
    let result = await rtAPI.security.call.getCurrentUser();
    rtAPI.security.updatePanels(result);
    return true
}

rtAPI.security.hardwareKey.loginStep1 = async function () {

    // send to server for registering
    let makeAssertionOptions;
    try {
        let result = await rtAPI.security.call.loginStep1();
        makeAssertionOptions = result.data;
    }
    catch (e) {
        console.error("Request to server failed", e);
        rtAPI.messages.showCritical(rtAPI.security.tFAData.text.hardwareKeyRequestToServerFailed);
        return false;
    }

    // show options error to user
    if (rtAPI.security.hardwareKey.debugEnabled) console.log("Assertion Options Object", makeAssertionOptions);
    if (makeAssertionOptions.status !== "ok") {
        console.error("Error creating assertion options");
        console.error(makeAssertionOptions.errorMessage);
        rtAPI.messages.showCritical(makeAssertionOptions.errorMessage);
        return false;
    }

    // todo: switch this to coercebase64
    const challenge = makeAssertionOptions.challenge.replace(/-/g, "+").replace(/_/g, "/");
    makeAssertionOptions.challenge = Uint8Array.from(atob(challenge), c => c.charCodeAt(0));

    // fix escaping. Change this to coerce
    makeAssertionOptions.allowCredentials.forEach(function (listItem) {
        var fixedId = listItem.id.replace(/\_/g, "/").replace(/\-/g, "+");
        listItem.id = Uint8Array.from(atob(fixedId), c => c.charCodeAt(0));
    });

    if (rtAPI.security.hardwareKey.debugEnabled) console.log("Assertion options", makeAssertionOptions);
    Swal.fire({
        title: rtAPI.security.tFAData.text.hardwareKeyLoggingInTitle,
        text: rtAPI.security.tFAData.text.hardwareKeyLoggingInText,
        imageUrl: "/resources/securitykey.min.svg",
        showCancelButton: true,
        showConfirmButton: false,
        focusConfirm: false,
        focusCancel: false
    });

    // ask browser for credentials (browser will ask connected authenticators)
    let credential;
    try {
        credential = await navigator.credentials.get({ publicKey: makeAssertionOptions })
        Swal.close();
    }
    catch (err) {
        Swal.close();
        console.error(err.message ? err.message : err);
        rtAPI.messages.showCritical(err.message ? err.message : err);
        return false;
    }

    try {
        return await rtAPI.security.hardwareKey.loginStep2(credential);
    }
    catch (e) {
        console.error("Could not verify assertion", e);
        rtAPI.messages.showCritical(rtAPI.security.tFAData.text.hardwareKeyCouldNotVerifyAssertion);
        return false;
    }
}

/**
 * Sends the credential to the the FIDO2 server for assertion
 * @param {any} assertedCredential
 */
rtAPI.security.hardwareKey.loginStep2 = async function (assertedCredential) {

    // Move data into Arrays incase it is super long
    let authData = new Uint8Array(assertedCredential.response.authenticatorData);
    let clientDataJSON = new Uint8Array(assertedCredential.response.clientDataJSON);
    let rawId = new Uint8Array(assertedCredential.rawId);
    let sig = new Uint8Array(assertedCredential.response.signature);
    const data = {
        assertedResponse: {
            id: assertedCredential.id,
            rawId: coerceToBase64Url(rawId),
            type: assertedCredential.type,
            extensions: assertedCredential.getClientExtensionResults(),
            response: {
                authenticatorData: coerceToBase64Url(authData),
                clientDataJson: coerceToBase64Url(clientDataJSON),
                signature: coerceToBase64Url(sig)
            }
        }
    };

    let response;
    try {
        let result = await rtAPI.security.call.loginStep2(data);
        response = result.data;
    }
    catch (e) {
        console.error("Request to server failed", e);
        rtAPI.messages.showCritical(rtAPI.security.tFAData.text.hardwareKeyRequestToServerFailed);
        return false;
    }

    if (rtAPI.security.hardwareKey.debugEnabled) console.log("Assertion Object", response);
    // show error
    if (response.status !== "ok") {
        console.error("Error doing assertion");
        console.error(response.errorMessage);
        rtAPI.messages.showCritical(response.errorMessage);
        return false;
    }

    // show success message
    await Swal.fire({
        title: rtAPI.security.tFAData.text.hardwareKeyLoggedInTitle,
        text: rtAPI.security.tFAData.text.hardwareKeyLoggedInText,
        icon: 'success',
        timer: 2000
    });
    rtAPI.messages.showInformation(rtAPI.security.tFAData.text.hardwareKeyLoggedInTitle);
    return true;

    // redirect to dashboard to show keys
    //window.location.href = "/dashboard/" + value("#login-username");
}

//#endregion

//#region Hardware Key Register
rtAPI.security.hardwareKey.registrationStep1 = async function () {

    const swalResult = await Swal.fire({
        padding: '15px',
        width: '40m',
        title: rtAPI.security.tFAData.text.enterHardwareKeyNameTitle,
        input: 'text',
        showCancelButton: true,
        inputPlaceholder: rtAPI.security.tFAData.text.enterHardwareKeyNameMessage,
        inputValidator: (value) => {
            if (!value) return rtAPI.security.tFAData.text.enterHardwareKeyNameMessage
        }
    })
    if (swalResult.isDismissed) return;

    // send to server for registering
    let makeCredentialOptions;
    try {
        let result = await rtAPI.security.call.registrationStep1();
        makeCredentialOptions = result.data;
    } catch (e) {
        console.error(e);
        rtAPI.messages.showCritical(rtAPI.security.tFAData.text.somethingWentWrong);
        return false;
    }


    if (rtAPI.security.hardwareKey.debugEnabled) console.log("Credential Options Object", makeCredentialOptions);
    if (makeCredentialOptions.status !== "ok") {
        console.error("Error creating credential options");
        console.error(makeCredentialOptions.errorMessage);
        rtAPI.messages.showCritical(makeCredentialOptions.errorMessage);
        return false;
    }

    // Turn the challenge back into the accepted format of padded base64
    makeCredentialOptions.challenge = coerceToArrayBuffer(makeCredentialOptions.challenge);
    // Turn ID into a UInt8Array Buffer for some reason
    makeCredentialOptions.user.id = coerceToArrayBuffer(makeCredentialOptions.user.id);

    makeCredentialOptions.excludeCredentials = makeCredentialOptions.excludeCredentials.map((c) => {
        c.id = coerceToArrayBuffer(c.id);
        return c;
    });

    if (makeCredentialOptions.authenticatorSelection.authenticatorAttachment === null) makeCredentialOptions.authenticatorSelection.authenticatorAttachment = undefined;

    if (rtAPI.security.hardwareKey.debugEnabled) console.log("Credential Options Formatted", makeCredentialOptions);
    Swal.fire({
        title: rtAPI.security.tFAData.text.registeringHardwareKeyNameTitle,
        text: rtAPI.security.tFAData.text.registeringHardwareKeyNameText,
        imageUrl: "/resources/securitykey.min.svg",
        showCancelButton: false,
        showConfirmButton: false,
        focusConfirm: false,
        focusCancel: false
    });


    if (rtAPI.security.hardwareKey.debugEnabled) console.log("Creating PublicKeyCredential...");
    let newCredential;
    try {
        newCredential = await navigator.credentials.create({ publicKey: makeCredentialOptions });
    } catch (e) {
        var msg = rtAPI.security.tFAData.text.publicKeyCredentialIssue;
        console.error(msg, e);
        rtAPI.messages.showCritical(msg);
        return false;
    }


    if (rtAPI.security.hardwareKey.debugEnabled) console.log("PublicKeyCredential Created", newCredential);
    try {
        return await rtAPI.security.hardwareKey.registrationStep2(newCredential, swalResult.value);
    }
    catch (err) {
        rtAPI.messages.showCritical(err.message ? err.message : err);
        return false
    }
}

// This should be used to verify the auth data with the server
rtAPI.security.hardwareKey.registrationStep2 = async function (newCredential, hardwareKeyFriendlyName) {

    // Move data into Arrays incase it is super long
    let attestationObject = new Uint8Array(newCredential.response.attestationObject);
    let clientDataJSON = new Uint8Array(newCredential.response.clientDataJSON);
    let rawId = new Uint8Array(newCredential.rawId);

    const data = {
        hardwareKeyFriendlyName: hardwareKeyFriendlyName,
        transports: newCredential.response.getTransports(),
        attestationResponse: {
            id: newCredential.id,
            rawId: coerceToBase64Url(rawId),
            type: newCredential.type,
            extensions: newCredential.getClientExtensionResults(),
            response: {
                attestationObject: coerceToBase64Url(attestationObject),
                clientDataJson: coerceToBase64Url(clientDataJSON)
            }
        }
    };

    let response;
    try {
        let result = await rtAPI.security.call.registrationStep2(data);
        response = result.data;
    } catch (e) {
        rtAPI.messages.showCritical(e);
        return false;
    }

    if (rtAPI.security.hardwareKey.debugEnabled) console.log("Credential Object", response);
    // show error
    if (response.status !== "ok") {
        console.error("Error creating credential");
        console.error(response.errorMessage);
        rtAPI.messages.showCritical(response.errorMessage);
        return false;
    }

    // show success 
    Swal.fire({
        title: rtAPI.security.tFAData.text.hardwareKeyRegistrationSuccessfulTitle,
        text: rtAPI.security.tFAData.text.hardwareKeyRegistrationSuccessfulText,
        icon: 'success',
        timer: 2000
    });
    rtAPI.messages.showInformation(rtAPI.security.tFAData.text.hardwareKeyRegistrationSuccessfulText);
    return true;
}

//#endregion

//#region Helpers

coerceToArrayBuffer = function (thing, name) {
    if (typeof thing === "string") {
        // base64url to base64
        thing = thing.replace(/-/g, "+").replace(/_/g, "/");

        // base64 to Uint8Array
        var str = window.atob(thing);
        var bytes = new Uint8Array(str.length);
        for (var i = 0; i < str.length; i++) {
            bytes[i] = str.charCodeAt(i);
        }
        thing = bytes;
    }

    // Array to Uint8Array
    if (Array.isArray(thing)) {
        thing = new Uint8Array(thing);
    }

    // Uint8Array to ArrayBuffer
    if (thing instanceof Uint8Array) {
        thing = thing.buffer;
    }

    // error if none of the above worked
    if (!(thing instanceof ArrayBuffer)) {
        throw new TypeError("could not coerce '" + name + "' to ArrayBuffer");
    }

    return thing;
};


coerceToBase64Url = function (thing) {
    // Array or ArrayBuffer to Uint8Array
    if (Array.isArray(thing)) {
        thing = Uint8Array.from(thing);
    }

    if (thing instanceof ArrayBuffer) {
        thing = new Uint8Array(thing);
    }

    // Uint8Array to base64
    if (thing instanceof Uint8Array) {
        var str = "";
        var len = thing.byteLength;

        for (var i = 0; i < len; i++) {
            str += String.fromCharCode(thing[i]);
        }
        thing = window.btoa(str);
    }

    if (typeof thing !== "string") {
        throw new Error("could not coerce to string");
    }

    // base64 to base64url
    // NOTE: "=" at the end of challenge is optional, strip it off here
    thing = thing.replace(/\+/g, "-").replace(/\//g, "_").replace(/=*$/g, "");

    return thing;
};



// HELPERS

function showErrorAlert(message, error) {
    let footermsg = '';
    if (error) {
        footermsg = 'exception:' + error.toString();
    }
    Swal.fire({
        icon: 'error',
        title: 'Error',
        text: message,
        footer: footermsg
        //footer: '<a href>Why do I have this issue?</a>'
    })
}

function detectFIDOSupport() {
    if (window.PublicKeyCredential === undefined ||
        typeof window.PublicKeyCredential !== "function") {
        //$('#register-button').attr("disabled", true);
        //$('#login-button').attr("disabled", true);
        var el = document.getElementById("notSupportedWarning");
        if (el) {
            el.style.display = 'block';
        }
        return;
    }
}

/**
 * 
 * Get a form value
 * @param {any} selector
 */
function value(selector) {
    var el = document.querySelector(selector);
    if (el.type === "checkbox") {
        return el.checked;
    }
    return el.value;
}

//#endregion